export default __webpack_public_path__ + "static/media/mobile-tracking.6644d7c5.png";